export default class ContactForm {
  constructor() {
    const submitBtn = $('.wpforms-submit-container').find('button');
    submitBtn.append(`<span class="icon">
    <svg width="50" height="8" viewBox="0 0 50 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M49.3536 3.64635C49.5488 3.84161 49.5488 4.1582 49.3536 4.35346L46.1716 7.53544C45.9763 7.7307 45.6597 7.7307 45.4645 7.53544C45.2692 7.34018 45.2692 7.02359 45.4645 6.82833L47.7929 4.4999L0 4.4999V3.4999L47.7929 3.4999L45.4645 1.17148C45.2692 0.976215 45.2692 0.659633 45.4645 0.46437C45.6597 0.269108 45.9763 0.269108 46.1716 0.46437L49.3536 3.64635Z" fill="#90ADCF"/>
    </svg>                  
  </span>`);
    // const buttons = $('.submit-button');
    // buttons.each((_, e) => {
    //   const parentForm = $(e).closest('form');
    //   parentForm.on('submit', (e) => {
    //     e.preventDefault();
    //     const mailValid = this.validateEmail(parentForm.find('#email'));
    //     const nameValid = this.validateName(parentForm.find('#name'));
    //     const lastnameValid = this.validateName(parentForm.find('#lastname'))
    //     const messageValid = this.validateName(parentForm.find('#message'));
    //     const phoneValid = this.validatePhoneNumber(parentForm.find('#phone'));

    //     if( mailValid && nameValid && lastnameValid && messageValid && phoneValid) {
    //         let data = {};
    //         data.email = parentForm.find('#email').val();
    //         data.name = parentForm.find('#name').val();
    //         data.lastname = parentForm.find('#lastname').val();
    //         data.phone = parentForm.find('#phone').val();
    //         data.message = parentForm.find('#message').val(); 
    //         this.sendMessage(data);
    //       }
    //   });
    // })
  }

  // sendMessage(data) {
  //   data.action = 'send_message';
    
  //   $.ajax({
  //     url: 'http://grupafarkas.dev.cogitech.pl/wp-admin/admin-ajax.php',
  //     type: 'POST',
  //     dataType: 'json',
  //     data: data,
  //     success: (response) => {
  //       console.log(response);
  //     }, error: (error) => {
  //       console.log(error);
  //     },
  //   });
  // }

  // validateName(name) {
  //   if (name.val() == '' || name.val() == undefined) {
  //     name.parent().addClass('invalid');
  //     return false;
  //   }
  //   name.parent().removeClass('invalid');
  //   return true;
  // }
  
  // validateEmail(email) {
  //   const regex = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
  //   if (email.val() == '' || regex.test(email.val()) == false || email.val() == undefined) {
  //     email.parent().addClass('invalid');
  //     return false;
  //   }
    
  //   email.parent().removeClass('invalid');
  //   return true;
  // }

  // validatePhoneNumber(phone) {
  //   const regex = /^[0-9]{9}$/i;
  //   if (phone.val() == '' || regex.test(phone.val()) == false || phone.val() == undefined) {
  //     phone.parent().addClass('invalid');
  //     return false;
  //   }
    
  //   phone.parent().removeClass('invalid');
  //   return true;
  // }
}


// WEBPACK FOOTER //
// ./scripts/components/contact.js